
define('eteration/ui/messages-cookies',[ 'jquery',
        'knockout',
        'underscore',
        'eteration/eteration',
        'eteration/eteration-i18n',
        'eteration/eteration-ajax',
        'eteration/ui/base-viewmodel',
        'ui-helper/cookie-helper',
        'ui-helper/storage-helper',
        'eteration/widgets/ui-cms'
    ],
    function($, ko, underscore, Eteration, i18n, etrAjax, BaseViewModel, cookieHelper, storageHelper) {
        
        function MessagesCookiesViewModel() {
            var self = this;

            var url = new URL(window.location.href);
            var isMobileRedirect = url.searchParams.has("mobile");
            if(isMobileRedirect) webViewCookie();

            ko.utils.extend(self, new BaseViewModel.BaseViewModel());

            var language = i18n.getUserLocale();
            var country = i18n.getUserCountry();

            window.dataLayer = window.dataLayer || [];
            function gtag() {
                dataLayer.push(arguments);
            }

            self.cookieLabels = ko.observable({
                'accept': i18n.get("Label-Genel-642"),
                'reject': i18n.get("Label-Genel-901"),
                'settings': i18n.get("Label-Genel-643")
            });

            var createMessage = function (key, value) {
                if(value != null && value != "" && !isMobileRedirect) {

                    value = i18n.get(value);

                    var translation = "empty";
                    var overlayElementId;

                    //Translate the header text now.
                    if (key == "importantMessage")
                        translation = i18n.get("Label-Genel-300");
                    else if (key == "attentionMessage")
                        translation = i18n.get("Label-Genel-301");
                    else if (key == "emergencyMessage")
                        translation = i18n.get("Label-Genel-302");
                    else if (key == "blueBlockMessage")
                        translation = "blueblock";
                    else if (key == "cookieWarningMessageNew") {
                        translation = i18n.get("Label-Genel-303");
                        overlayElementId = "cookieWarningOverlay";
                    }
                    else if (key == "localStorageWarningMessage")
                        translation = i18n.get("Label-Genel-306");
                    else if(key == "cookieDisabledMessage"){
                        translation = i18n.get("Label-Genel-306");
                    }else if( key == "crisisMessage"){
                        translation = i18n.get("Label-Genel-307");
                    }

                    if (translation == "empty")
                        console.log("message translation is null so do not show it !");
                    else
                        showMessage(key, translation, value, overlayElementId);
                }
            };

            var showMessage = function (type, title, content, overlayElementId) {
                if(document.getElementById(type)){
                    document.getElementById(type).style.display = "block";

                    if(document.getElementById(overlayElementId))
                        document.getElementById(overlayElementId).style.display = "block";

                    if (type != "blueBlockMessage") {
                        var headerID = type + "Header";
                        if(document.getElementById(headerID)){
                            document.getElementById(headerID).innerHTML = title;
                        }
                    }
                    var paragID = type + "Parag";
                    document.getElementById(paragID).innerHTML = content;
                }
            };

            var scrollingDiv = document.getElementById('schedulenew');
            setTimeout(function () {
                var scrollerDiv = document.getElementById('errorContent');

                if (scrollingDiv && scrollingDiv.length > 0 && scrollerDiv.childNodes[0] != null) {
                    var scrollerDivHeight = scrollerDiv.offsetHeight;
                    scrollingDiv.style.marginTop = scrollerDivHeight + 'px';
                }
            },350);

            $('#errorContent .close').click( function() {
                var closedDivHeight = $(this).parent()[0].offsetHeight;
                var newMarginHeight = parseInt(scrollingDiv.style.marginTop) - closedDivHeight;
                scrollingDiv.style.marginTop = newMarginHeight + 'px';
            });

            var localStorageSupported = function() {
                if(typeof localStorage === 'undefined'){
                    return false;
                }

                var test = 'test';
                try {
                    localStorage.setItem(test, test);
                    localStorage.removeItem(test);
                    return true;
                } catch(e) {
                    return false;
                }
            };

            var cookiesEnabled = function()
            {
                var cookieEnabled = (navigator.cookieEnabled) ? true : false;

                if (typeof navigator.cookieEnabled == "undefined" && !cookieEnabled)
                {
                    document.cookie="testcookie";
                    cookieEnabled = (document.cookie.indexOf("testcookie") != -1) ? true : false;
                }
                return cookieEnabled;
            };

            var checkCrisisPageActive = JSON.parse(storageHelper.getItem({ key: "IS_CRISIS_HOMEPAGE_LOGO", webStorageType: storageHelper.Stores.SESSION_STORAGE }));
            if (checkCrisisPageActive && document.querySelector('.header-tk-brand') != null) {
                document.querySelector('.header-tk-brand').style.filter ="grayscale(1)";
            }

            //COOKIE DEVELOPMENT
            function setCookie(cookie,boolean){
                cookieHelper.setCookie(cookie, boolean, 5000, true);
            }		
            
            function checkCookieType(cookieList, status){
                cookieList.forEach(function(cookie) {
                    if(status == "reject"){
                        if(cookie == "COOKIE_WARNING_REJECTED"){
                            setCookie(cookie,"true");							
                        }
                        else if (cookie == "COOKIE_WARNING_VIEWED"){
                            setCookie(cookie,"true");		
                        }else{
                            setCookie(cookie,"false");
                        }
                    }
                    else if (status == "accept"){
                        if(cookie != "COOKIE_WARNING_REJECTED"){
                            setCookie(cookie,"true");							
                        }else if (cookie == "COOKIE_WARNING_VIEWED"){
                            setCookie(cookie,"true");	
                        }else{
                            setCookie(cookie,"false");
                        }
                    }						  
                });					
            }

            function setConsentCookie(id,cookieList) {
                
                if(underscore.isNull(cookieList) || underscore.isUndefined(cookieList)){
                    var cookieList = id;
                    for (var i = 0; i < cookieList.length; i++) {		
                        if (!cookieHelper.getCookie(cookieList[i])) {
                                createMessage("cookieWarningMessageNew", "Label-Genel-304");
                                setCookie(cookieList[i],"false");
                        } else if(cookieList[i] == "COOKIE_WARNING_VIEWED" && cookieHelper.getCookie(cookieList[i]) != "true") {			                               
                                createMessage("cookieWarningMessageNew", "Label-Genel-304");

                        }
                    }								
                } else {
                    switch (id) {
                        case "cookieWarningAcceptId":
                            $('#cookieWarningMessageNew').toggle();
                            $('#cookieWarningOverlay').toggle();
                            setNewConsentMode({
                                ad_storage: true,
                                ad_user_data: true,
                                ad_personalization: true,
                                analytics_storage: true,
                                functionality_storage: true,
                                personalization_storage: true,
                                security_storage: true
                            });
                            checkCookieType(cookieList, "accept");					
                            break;
                        case "cookieWarningRejectId":
                            $('#cookieWarningMessageNew').toggle();
                            $('#cookieWarningOverlay').toggle();
                            setNewConsentMode({
                                ad_storage: false,
                                ad_user_data: false,
                                ad_personalization: false,
                                analytics_storage: false,
                                functionality_storage: false,
                                personalization_storage: false,
                                security_storage: true
                            });
                            checkCookieType(cookieList, "reject");
                            break;
                        default:
                            var el = $(this).parent('.notice');
                            var headerheight = $('.navbar-fixed-top').height() - el.height() - 59;
                            el.slideUp('slow', function() {
                                el.remove();
                            });
                            $('header').animate({
                                height: headerheight
                            }, 'slow');
                            break;
                    }				
                }
            }

            function setNewConsentMode(consent) {
                var consentMode = {
                    ad_storage: consent.ad_storage ? "granted" : "denied",
                    ad_user_data: consent.ad_user_data ? "granted" : "denied",
                    ad_personalization: consent.ad_personalization ? "granted" : "denied",
                    analytics_storage: consent.analytics_storage ? "granted" : "denied",
                    functionality_storage: consent.functionality_storage ? "granted" : "denied",
                    personalization_storage: consent.personalization_storage ? "granted" : "denied",
                    security_storage: consent.security_storage ? "granted" : "denied",
                };
                gtag("consent", "update", consentMode);
                localStorage.setItem("consentMode", JSON.stringify(consentMode));
            }

            function webViewCookie(){
                cookieHelper.setCookie("COOKIE_WARNING_VIEWED", "true", 5000, true);

                var mobileParam = url.searchParams.get("mobile");
                if (!mobileParam){
                    cookieHelper.setCookie("COOKIE_WARNING_REJECTED", "true", 5000, true);
                    window.history.replaceState(null, '', location.pathname);
                    return;
                }

                var hasAnalytics = mobileParam.includes("analytics");
                var hasFunctionality = mobileParam.includes("functionality");
                var hasMarketing = mobileParam.includes("marketing");

                if (hasAnalytics) {
                    cookieHelper.setCookie("COOKIE_ANALYTICS", "true", 5000, true);
                    gtag("consent", "update", { analytics_storage: "granted" });
                }
                if (hasFunctionality) {
                    cookieHelper.setCookie("COOKIE_FUNCTIONAL", "true", 5000, true);
                    gtag("consent", "update", {
                        functionality_storage: "granted",
                        personalization_storage: "granted"
                    });
                }
                if (hasMarketing) {
                    cookieHelper.setCookie("COOKIE_ADVERTISEMENTS", "true", 5000, true);
                    gtag("consent", "update", {
                        ad_storage: "granted",
                        ad_user_data: "granted",
                        ad_personalization: "granted"
                    });
                }
                if (hasAnalytics || hasFunctionality || hasMarketing) {
                    cookieHelper.setCookie("COOKIE_WARNING_ACCEPTED", "true", 5000, true);
                }

                window.history.replaceState(null, '', location.pathname);
            }

            var getMessages = {

                app : 'app.common',
                service : '/messages/generalimportantmessages/'+language+'/'+country,
                disableLoader : true,
                cache : true,
                cdn : true,
                callback : function(data) {
                    var responseStr =JSON.stringify(data);
                    console.log(responseStr);
                    if(responseStr.indexOf("ERROR") > -1) {
                        console.log("Error in Response");
                    }
                    else {
                        var cookieList = [
                            "COOKIE_WARNING_VIEWED",
                            "COOKIE_FUNCTIONAL",
                            "COOKIE_ADVERTISEMENTS",
                            "COOKIE_ANALYTICS",
                            "COOKIE_WARNING_ACCEPTED",
                            "COOKIE_WARNING_REJECTED"
                            ];

                        setConsentCookie(cookieList);

                        if (!localStorageSupported()) {
                            createMessage("localStorageWarningMessage", "Label-Genel-306");
                        }

                        if (!cookiesEnabled()) {
                            createMessage("cookieDisabledMessage", "Label-Genel-306");
                        }

                        var messages = data.data;
                        $.each(messages, function(key, value) {
                            createMessage(key, value);
                        });

                        $('.notice button').click(function(){
                            var el = $(this).parent('.notice');
                            el.slideUp('slow',function(){ el.remove(); });
                        });

                        $("#cookieWarningCloseId").click(function(){
                            if(document.getElementById("signupModal") != null)
                                document.getElementById("signupModal").style.marginTop = "0px";
                        });

                        if($('.navbar-fixed-top')) {
                            $('header').height($('.navbar-fixed-top').height() - 1);
                            $(window).resize(function() {
                                $('header').height($('.navbar-fixed-top').height() - 1);
                            });
                        }

                        $('#cookieWarningMessageNew button.cookieWarning-btn').click(function(){
                            var consentButtonId = $(this).attr('id');
                            setConsentCookie(consentButtonId, cookieList);

                        });

                    }
                }
            };//ajax bitim

            etrAjax.get(getMessages);

            $(document).on("click", "#cookieWarningOptionChangeId", function () {
                $('header').css("z-index", "1072");
            });

            $(document).on("click", "#cookieWarningOptionmodalConfirm", function () {
                $('header').css("z-index", "1052");
                setNewConsentMode({
                    ad_storage: document.getElementById("advertisementsCookies").checked,
                    ad_user_data: document.getElementById("advertisementsCookies").checked ? true : false,
                    ad_personalization: document.getElementById("advertisementsCookies").checked ? true : false,
                    analytics_storage: document.getElementById("analyticsCookies").checked,
                    functionality_storage: document.getElementById("functionalCookies").checked,
                    security_storage: true,
                    personalization_storage: document.getElementById("functionalCookies").checked ? true : false,
                });
            });

            etrAjax.get({
                app : 'app.cms',
                service : '/content/getCrisisPageMessages',
                disableLoader:true,
                cache:false,
                callback : function(response) {

                    if (response.data.length > 0) {
                        var crisisMessages = response.data;
                        $.each(crisisMessages, function(key, value) {
                            key = "crisisMessage";
                            createMessage(key, value);
                        });
                    }
                }
            });

    
        }
        

        return { ViewModel:  MessagesCookiesViewModel };
    });
